import React from "react";

export default function LegalPage({ pageKey }) {
  const content = {
    privacy: {
      title: "Privacy Policy",
      desc: "This policy details how Aroveniq Solutions LLP processes, secures, and safeguards your corporate and vendor tracking data."
    },
    terms: {
      title: "Terms of Service",
      desc: "Review the general terms of service, platform service level parameters, and legal provisions for deploying the Aroveniq intelligence layer."
    }
  };

  const selected = content[pageKey] || content.privacy;

  return (
    <div className="bg-[#05050A] text-white min-h-screen py-24 relative overflow-hidden" data-testid="legal-page">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 space-y-8">
        <h1 className="text-4xl font-black font-display tracking-tighter border-b border-white/10 pb-4">{selected.title}</h1>
        <p className="text-[#ABA3C2] text-sm leading-relaxed font-body">{selected.desc}</p>
        <div className="space-y-4 text-xs text-zinc-500 font-body leading-relaxed">
          <p>Last modified: January 2026</p>
          <p>
            Aroveniq Solutions LLP provides an independent, public-facing marketing showcase. This site provides conceptual and simulated demonstrations of SaaS vendor tracking dashboards, score metrics, and risk calculators.
          </p>
          <p>
            All submitted lead emails, full names, and company details are logged securely into our local MongoDB data collections as part of the client validation and demo-booking workflow. We never lease, trade, or distribute your email records to third-party brokers.
          </p>
        </div>
      </div>
    </div>
  );
}